import axios from 'axios';

export default class EspecieTituloService {
    constructor(http, store) {
        this._http = http;
        this._store = store;
    }

    async listarEspecies(params) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API +
                    'especie-titulos',
                {
                    params: params,
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async criarEspecie(dados) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API +
                    'especie-titulos',
                dados,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async atualizarEspecie(cdEspecieTitulo, dados) {
        try {
            const response = await axios.put(
                process.env.VUE_APP_RECUPERI_API +
                    `especie-titulos/${cdEspecieTitulo}`,
                dados,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }
}
